import { gql } from '@apollo/client';

export const CREATE_LOST_ANIMAL = gql`
  mutation CreateLostAnimal($input: CreateLostAnimalInput!) {
    createLostAnimal(input: $input) {
      _id
      contactName
      contactPhone
      contactEmail
      location {
        type
        coordinates
      }
      animalName
      animalType
      animalImageUrl
      breed
      colorMarkings
      dateLost
      rewardAmount
      sex
      lastSeen
      estimatedWeight
      approachable
      createdAt
      updatedAt
      language
    }
  }
`;

export const UPDATE_LOST_ANIMAL = gql`
  mutation UpdateLostAnimal($_id: ID!, $input: UpdateLostAnimalInput!) {
    updateLostAnimal(_id: $_id, input: $input) {
      _id
      contactName
      contactPhone
      contactEmail
      location {
        type
        coordinates
      }
      animalName
      animalType
      animalImageUrl
      breed
      colorMarkings
      dateLost
      rewardAmount
      sex
      lastSeen
      estimatedWeight
      approachable
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_LOST_ANIMAL = gql`
  mutation DeleteLostAnimal($_id: ID!) {
    deleteLostAnimal(_id: $_id) {
      _id
    }
  }
`;

export const UPDATE_LOST_REUNITED_STATUS = gql`
  mutation UpdateLostReunitedStatus($_id: ID!, $reunited: Boolean!) {
    updateLostReunitedStatus(_id: $_id, reunited: $reunited) {
      _id
      reunited
      updatedAt
    }
  }
`;
